module.exports = __webpack_public_path__ + "static/media/shiftChangeArrowGreen.58e76b5d.svg";